export class ProviderMedicationGroup {
    providerMedicationGroupId: number;
    specializationId?: number;
    createdBy: number;
    modifiedBy?: number;
    createdDate: Date;
    modifiedDate?: Date;
    tagName: string;
}
